"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const AuthContext_1 = require("context/AuthContext");
const UserContext_1 = require("context/UserContext");
const LoadingSplashScreen_1 = __importDefault(require("components/shared/LoadingSplashScreen"));
const LoginAuto = () => {
    const { checkUseSSO } = (0, AuthContext_1.useAuth)();
    const { organization, user } = (0, UserContext_1.useUser)();
    const useSSOMechanism = checkUseSSO();
    (0, react_1.useEffect)(() => {
        if (useSSOMechanism && !user) {
            window.location.replace(organization === null || organization === void 0 ? void 0 : organization.loginUrl);
        }
        else {
            window.location.replace('/login/email');
        }
    }, [organization === null || organization === void 0 ? void 0 : organization.loginUrl, useSSOMechanism, user]);
    return react_1.default.createElement(LoadingSplashScreen_1.default, null);
};
exports.default = LoginAuto;
